import { NgModule } from '@angular/core';

import { JobApplicationSharedModule } from './jobapplication-shared.module';
import { JobApplicationRoutesModule } from './jobapplication.routes';
import { JobApplicationService } from './service/jobapplication.service';

/**
 * CoreModule for jobapplications.
 */
@NgModule( {
    imports: [
        JobApplicationSharedModule,
        JobApplicationRoutesModule
    ],
    declarations: [
    ],
    exports: [
        JobApplicationSharedModule
    ],
    providers: [
        JobApplicationService
    ],
} )

export class JobApplicationCoreModule {
}
